export const HIDDeviceObj =
{
    curDeviceMode:null,
    curDeviceHandle:null,//当前设备句柄
    curWebHandle:null,
    FirmwareID:-1,
    FirmwareVer:-1,
    FirmwareNum:-1,
    FirmwareFull:-1,
    RunMode:-1,
    SN:-1,
    SNDatas:-1,
    SignDatas:-1,
    SignSN:-1,
    SignCRC:-1,
    ProfileIndex:-1,
    curWebSite:'',
    reteVal:0,
    macStatus:0,
    winKeyStatus:0,
    FirstFlag:-1,
    SerialNumber:-1,

    modeLigth:1,
    modeChildLigth:1,
    brightnessLigth:1,
    speedLigth:1,
    sleep:2,
    journey_global:2,
    rt_all_journey:0,
    curMaxJourney:0,//实时获取最大行程变化的值
    curMaxJourneyKeyStatus:0,//实时获取最大行程按键触发状态
    keyMapStructure:
    {
        "index":-1,//矩阵单维ID
        "key_name":"",//按键名称
        "name":"",//按键字符
        "hid":0,//按键HID值
        "axisSet":
        {
            "brand":"",
            "name":"",
            "model":""
        },
        "journey":0,//按键实时行程值
        "adc_data":0,//按键实时ADC行程
        "key_status":0,//按键实时转态
        "fn":0,//FN层锁定
        "fn_custom"://按键自定义
        {
            "fn_code":"",
            "type":"",//自定义功能类型
            "name":"",//功能名称
            "content":"",//功能内容
        },
        "is_set":1,//支持自定义
        "custom"://按键自定义
        {
            "type":"",//自定义功能类型
            "name":"",//功能名称
            "content":"",//功能内容
        },
        "journey_RT":
        {
            "down":"-",
            "up":"-"
        },
        "journey_global":"-",
        "safe_zone_top":"-",
        "safe_zone_bottom":"-",
        "journey_trigger":"-",
        "select":0,
        "working_mode":0
    },
    MatrixList:
    {
        MatrixKey:[],

        MatrixADCTemp:[],
        MatrixADC:[],
        MatrixJourneyTemp:[],
        MatrixJourney:[],

        MatrixLayout0Temp:[],
        MatrixLayout0:[],

        MatrixLayout1Temp:[],
        MatrixLayout1:[],

        MatrixLayout4Temp:[],
        MatrixLayout4:[],

        MatrixLayout14Temp:[],
        MatrixLayout14:[],

        MatrixLayout15Temp:[],
        MatrixLayout15:[],

        MatrixLayout16Temp:[],
        MatrixLayout16:[],

        MatrixLayout17Temp:[],
        MatrixLayout17:[],

        MatrixLayout8Temp:[],
        MatrixLayout8:[],

        MatrixKeyStatus:[],
        KeyMap:[]
    },
    ListenID:-1,
    typeMatrixID:-1,
    typeMatrixPageID:-1,
    inPage: 0,
    //发送读取键盘矩阵信息
    redMatrix(cmdObj)
    {
        const outputReportData1 = new Uint8Array(cmdObj.READ_DEFKEY_MATRIX_CMD.ROW1_ROW2.map(hex => parseInt(hex, 16)));
        this.curDeviceHandle.sendReport(0,outputReportData1);

        setTimeout(()=>{

            const outputReportData2 = new Uint8Array(cmdObj.READ_DEFKEY_MATRIX_CMD.ROW3_ROW4.map(hex => parseInt(hex, 16)));
            this.curDeviceHandle.sendReport(0,outputReportData2);
            
        },500);

        setTimeout(()=>{

            const outputReportData3 = new Uint8Array(cmdObj.READ_DEFKEY_MATRIX_CMD.ROW5_ROW6.map(hex => parseInt(hex, 16)));
            this.curDeviceHandle.sendReport(0,outputReportData3);
            
        },1000);
        
    },
    sendHidDataCallBack()
    {
        this.curWebHandle.refreshHIDeviceData();
    },
    //获取CRC
    getCRC(len,cmd,endData)
    {
        return 0x35 + 0x5c + parseInt(len,16) + parseInt(cmd,16) +  parseInt(endData,16);
    },
    //根据按键名称查询HID对象
    getBottonHidOJBFromName(KeyboardMapConf,Value)
    {
        Value = this.isNumber(parseInt(Value))?"U"+Value:Value;

        let map = KeyboardMapConf.KEYMAP;
        for(var i in map)
        {
            if(map[i].Value ==  Value)
            {
                return map[i];
            }
        }
    },
    //根据TASK查询HID对象
    getBottonHidOJBFromTask(KeyboardMapConf,Value)
    {
        Value = this.isNumber(parseInt(Value))?"U"+Value:Value;

        let map = KeyboardMapConf.KEYMAP;
        for(var i in map)
        {
            if(map[i].Task ==  Value)
            {
                return map[i];
            }
        }
    },
    //根据HID查询HID对象
    getBottonHidOJBFromHID(KeyboardMapConf,Value)
    {
        let map = KeyboardMapConf.KEYMAP;
        for(var i in map)
        {
            if(parseInt(map[i].Hid,16) == Value)
            {
                return map[i];
            }
        }
    },
    getBottonHidOJBFromHIDMedia(KeyboardMapFnConf,Value)
    {
        for(let x in KeyboardMapFnConf)
        {
            for(let z in KeyboardMapFnConf[x])
            {
                if(Value == KeyboardMapFnConf[x][z].code)
                {
                    return KeyboardMapFnConf[x][z];
                }
            }
        }
    },
    //开启普通数据监听
    startListeningNormal(cmdObj)
    {
        const context = this;
        this.ListenID = setInterval(function()
        {
            //读取行程第一段数据
            setTimeout(()=>
            {
                const outputReportData1 = new Uint8Array(cmdObj.READ_RM6X21_HALL_16BIT_CMD.ROW1_ROW3.map(hex => parseInt(hex, 16)));
                context.typeMatrixID       = parseInt(cmdObj.READ_RM6X21_HALL_16BIT_CMD.ROW1_ROW3[4],16);
                context.typeMatrixPageID   = parseInt(cmdObj.READ_RM6X21_HALL_16BIT_CMD.ROW1_ROW3[5],16);
                context.curDeviceHandle.sendReport(0,outputReportData1);

            },1);
            //读取行程第二段数据
            setTimeout(()=>
            {
                const outputReportData2 = new Uint8Array(cmdObj.READ_RM6X21_HALL_16BIT_CMD.ROW4_ROW6.map(hex => parseInt(hex, 16)));
                context.typeMatrixID       = parseInt(cmdObj.READ_RM6X21_HALL_16BIT_CMD.ROW4_ROW6[4],16);
                context.typeMatrixPageID   = parseInt(cmdObj.READ_RM6X21_HALL_16BIT_CMD.ROW4_ROW6[5],16);
                context.curDeviceHandle.sendReport(0,outputReportData2);
            },10);


            //读取ADC第一段数据
            setTimeout(()=>
            {
                const outputReportData1_1 = new Uint8Array(cmdObj.READ_RM6X21_ADC_16BIT_CMD.ROW1_ROW3.map(hex => parseInt(hex, 16)));
                context.typeMatrixID       = parseInt(cmdObj.READ_RM6X21_ADC_16BIT_CMD.ROW1_ROW3[4],16);
                context.typeMatrixPageID   = parseInt(cmdObj.READ_RM6X21_ADC_16BIT_CMD.ROW1_ROW3[5],16);
                context.curDeviceHandle.sendReport(0,outputReportData1_1);

            },20);
            //读取ADC第二段数据
            setTimeout(()=>
            {
                const outputReportData2_2 = new Uint8Array(cmdObj.READ_RM6X21_ADC_16BIT_CMD.ROW4_ROW6.map(hex => parseInt(hex, 16)));
                context.typeMatrixID       = parseInt(cmdObj.READ_RM6X21_ADC_16BIT_CMD.ROW4_ROW6[4],16);
                context.typeMatrixPageID   = parseInt(cmdObj.READ_RM6X21_ADC_16BIT_CMD.ROW4_ROW6[5],16);
                context.curDeviceHandle.sendReport(0,outputReportData2_2);
            },30);
            


            //读取按键状态
            setTimeout(()=>
            {
                const outputReportData3 = new Uint8Array(cmdObj.READ_RM6X21_KEYSTATUS_8BIT_CMD.map(hex => parseInt(hex, 16)));
                context.typeMatrixID       = parseInt(cmdObj.READ_RM6X21_KEYSTATUS_8BIT_CMD[4],16);
                context.typeMatrixPageID   = parseInt(cmdObj.READ_RM6X21_KEYSTATUS_8BIT_CMD[5],16);
                context.curDeviceHandle.sendReport(0,outputReportData3);
            },40);
            

        },60);
    },
    //开启高速数据监听
    startListeningHigh(cmdObj)
    {
        const context = this;
        this.ListenID = setInterval(function()
        {
            //读取行程第一段数据
            setTimeout(()=>
            {
                const outputReportData1 = new Uint8Array(cmdObj.READ_RM6X21_HALL_16BIT_CMD.ROW1_ROW3.map(hex => parseInt(hex, 16)));
                context.typeMatrixID       = parseInt(cmdObj.READ_RM6X21_HALL_16BIT_CMD.ROW1_ROW3[4],16);
                context.typeMatrixPageID   = parseInt(cmdObj.READ_RM6X21_HALL_16BIT_CMD.ROW1_ROW3[5],16);
                context.curDeviceHandle.sendReport(0,outputReportData1);

            },1);
            //读取行程第二段数据
            setTimeout(()=>
            {
                const outputReportData2 = new Uint8Array(cmdObj.READ_RM6X21_HALL_16BIT_CMD.ROW4_ROW6.map(hex => parseInt(hex, 16)));
                context.typeMatrixID       = parseInt(cmdObj.READ_RM6X21_HALL_16BIT_CMD.ROW4_ROW6[4],16);
                context.typeMatrixPageID   = parseInt(cmdObj.READ_RM6X21_HALL_16BIT_CMD.ROW4_ROW6[5],16);
                context.curDeviceHandle.sendReport(0,outputReportData2);
            },6);


            //读取ADC第一段数据
            setTimeout(()=>
            {
                const outputReportData1_1 = new Uint8Array(cmdObj.READ_RM6X21_ADC_16BIT_CMD.ROW1_ROW3.map(hex => parseInt(hex, 16)));
                context.typeMatrixID       = parseInt(cmdObj.READ_RM6X21_ADC_16BIT_CMD.ROW1_ROW3[4],16);
                context.typeMatrixPageID   = parseInt(cmdObj.READ_RM6X21_ADC_16BIT_CMD.ROW1_ROW3[5],16);
                context.curDeviceHandle.sendReport(0,outputReportData1_1);

            },11);
            //读取ADC第二段数据
            setTimeout(()=>
            {
                const outputReportData2_2 = new Uint8Array(cmdObj.READ_RM6X21_ADC_16BIT_CMD.ROW4_ROW6.map(hex => parseInt(hex, 16)));
                context.typeMatrixID       = parseInt(cmdObj.READ_RM6X21_ADC_16BIT_CMD.ROW4_ROW6[4],16);
                context.typeMatrixPageID   = parseInt(cmdObj.READ_RM6X21_ADC_16BIT_CMD.ROW4_ROW6[5],16);
                context.curDeviceHandle.sendReport(0,outputReportData2_2);
            },16);
            


            //读取按键状态
            setTimeout(()=>
            {
                const outputReportData3 = new Uint8Array(cmdObj.READ_RM6X21_KEYSTATUS_8BIT_CMD.map(hex => parseInt(hex, 16)));
                context.typeMatrixID       = parseInt(cmdObj.READ_RM6X21_KEYSTATUS_8BIT_CMD[4],16);
                context.typeMatrixPageID   = parseInt(cmdObj.READ_RM6X21_KEYSTATUS_8BIT_CMD[5],16);
                context.curDeviceHandle.sendReport(0,outputReportData3);
            },21);
            

        },30);
    },
    //关闭行程数据监听
    stopListening()
    {
        clearInterval(this.ListenID);
    },
    //按键数据结构化
    formatKeyMapMatrix(KeyboardMapConf)
    {
        let getKeyItem = function(hid)
        {
            let map = KeyboardMapConf.KEYMAP;
            for(var i in map)
            {
                if(parseInt(map[i].Hid,16) ==  parseInt(hid,16))
                {
                    return map[i];
                }
            }
        } 

        let KeyMap = [];
        let c= 0;
        for(let i=0;i<6;i++)
        {
            let curRowArrObj = [];
            let curRow = this.MatrixList.MatrixKey[i];
            for(let j = 0;j<21;j++)
            {
                var keyMapObj = parseInt(curRow[j],16) == 0?0:getKeyItem(curRow[j]);
                let curObj = 
                {
                    "index":c,
                    "key_name":keyMapObj?keyMapObj.Value:0,
                    "name":keyMapObj?keyMapObj.Name:0,
                    "hid":curRow[j],
                    "axisSet":
                    {
                        "brand":"",
                        "name":"",
                        "model":""
                    },
                    "journey":0,
                    "adc_data":0,

                    "fn":0,//FN层锁定
                    "fn_custom"://按键自定义
                    {
                        "fn_code":"",
                        "type":"",//自定义功能类型
                        "name":"",//功能名称
                        "content":"",//功能内容
                    },
                    "is_set":1,//支持自定义
                    "custom"://按键自定义
                    {
                        "type":"",//自定义功能类型
                        "name":"",//功能名称
                        "content":"",//功能内容
                    },
                    "journey_RT":
                    {
                        "down":"-",
                        "up":"-"
                    },
                    "journey_trigger":"-",
                    "journey_global":"-",
                    "safe_zone_top":"-",
                    "safe_zone_bottom":"-",
                    "select":false,
                    "working_mode":0
                };
                curRowArrObj.push(curObj);
                c++;
            }
            KeyMap.push(curRowArrObj);
        }

        this.MatrixList.KeyMap = KeyMap;
    },
    //行程数据结构化
    formatJourneyMapMatrix()
    {
        // if(this.MatrixList.MatrixJourney.length<126)
        //     return;

        let c= 0;
        for(var i=0;i < 6;i++)
        {
            for(var j=0;j < 21 ;j++)
            {
                this.MatrixList.KeyMap[i][j].journey = this.MatrixList.MatrixJourney[c];
                this.MatrixList.KeyMap[i][j].adc_data = this.MatrixList.MatrixADC[c];
                this.MatrixList.KeyMap[i][j].key_status = this.MatrixList.MatrixKeyStatus[c];
                
                c++;
            }
        }

    },
    //读取设置矩阵原数据
    setMatrixKey(reData)
    {
        const rows = this.toHexStringArr(reData);
        const row1 = rows.slice(6,27);
        const row2 = rows.slice(28,49);
        this.MatrixList.MatrixKey.push(row1,row2);
    },
    //读取行程按键相关数据
    setMatrixJourneyHeadData(reData,cmdObj)
    {
        const rows      =  this.toHexStringArr(reData);
        if(this.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_CODE.ADC_HALL_CODE) && (this.typeMatrixPageID == 1))
        {//Hall 行程实时数据   
            const data      = rows.slice(6,64);
            this.MatrixList.MatrixJourneyTemp = data;

            this.inPage = 1;
        }
        else if(this.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_CODE.ADC_HALL_CODE))
        {//Hall 行程实时数据
            const data      = rows.slice(6,64);
            this.MatrixList.MatrixJourneyTemp.push.apply(this.MatrixList.MatrixJourneyTemp, data);

            this.inPage = 1;
        }
        else if(this.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_CODE.ADC_ORIGINAL_CODE) && (this.typeMatrixPageID == 1))
        {//ADC实时数据   
            const data      = rows.slice(6,64);
            this.MatrixList.MatrixADCTemp = data;

            this.inPage = 1;
        }
        else if(this.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_CODE.ADC_ORIGINAL_CODE))
        {//ADC实时数据
            const data      = rows.slice(6,64);
            this.MatrixList.MatrixADCTemp.push.apply(this.MatrixList.MatrixADCTemp, data);

            this.inPage = 1;
        }

        else if(this.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_CODE.KEY_STATUS_CODE))
        {//按键状态

            this.inPage = 1;
            //处理数据
            this.formatJourney();
            this.formatJourneyMapMatrix();
            this.sendHidDataCallBack();

            this.curMaxJourneyKeyStatus = 0;
            const data      = rows.slice(6,64);
            this.MatrixList.MatrixKeyStatus = data;
        }

    },
    setMatrixJourneyNOHeadData(reData,cmdObj)
    {
        if(this.typeMatrixID ==  parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_CODE.ADC_HALL_CODE))
        {//Hall 行程实时数据  

            this.inPage++;
            const rows      =  this.toHexStringArr(reData);
            // let index       = rows.indexOf("ff");
            let index = this.inPage == 3?4:64;

            const data      = rows.slice(0,index);
            this.MatrixList.MatrixJourneyTemp.push.apply(this.MatrixList.MatrixJourneyTemp, data);
        }
        else if(this.typeMatrixID ==  parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_CODE.ADC_ORIGINAL_CODE))
        {//ADC实时数据  

            this.inPage++;
            const rows      =  this.toHexStringArr(reData);
            // let index       = rows.indexOf("ff");
            let index = this.inPage == 3?4:64;

            const data      = rows.slice(0,index);
            this.MatrixList.MatrixADCTemp.push.apply(this.MatrixList.MatrixADCTemp, data);
        }
        else if(this.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_CODE.KEY_STATUS_CODE))
        {//按键状态数据  

            this.inPage++;
            const rows      =  this.toHexStringArr(reData);
            // let index       = rows.indexOf("ff");
            //     index = index == -1?0:index;
            let index = this.inPage == 3?4:64;

            const data      = rows.slice(0,index);
            this.MatrixList.MatrixKeyStatus.push.apply(this.MatrixList.MatrixKeyStatus, data);
        }
    },
    formatJourney()
    {
        this.MatrixList.MatrixJourney = [];
        this.MatrixList.MatrixJourneyTemp = this.MatrixList.MatrixJourneyTemp.slice(0,252);

        //行程数据转化
        for(var i=0;i < this.MatrixList.MatrixJourneyTemp.length;i++)
        {
            if(i%2 == 0)
            {
                var Nval = parseInt(this.MatrixList.MatrixJourneyTemp[i+1],16);
                Nval = ((Nval & 0xFF) << 8) | ((Nval & 0xFF00) >> 8);

                var keyVal =  Nval + parseInt(this.MatrixList.MatrixJourneyTemp[i],16);
                this.MatrixList.MatrixJourney.push(keyVal);
            }
        }


        this.MatrixList.MatrixADC = [];
        this.MatrixList.MatrixADCTemp = this.MatrixList.MatrixADCTemp.slice(0,252);
        //ADC数据转化
        for(var i=0;i < this.MatrixList.MatrixADCTemp.length;i++)
        {
            if(i%2 == 0)
            {
                var Nval = parseInt(this.MatrixList.MatrixADCTemp[i+1],16);
                Nval = ((Nval & 0xFF) << 8) | ((Nval & 0xFF00) >> 8);

                var keyVal =  Nval + parseInt(this.MatrixList.MatrixADCTemp[i],16);
                this.MatrixList.MatrixADC.push(keyVal);
            }
        }


        //按键状态数据转化
        for(var i in this.MatrixList.MatrixKeyStatus)
        {
            this.MatrixList.MatrixKeyStatus[i] = parseInt(this.MatrixList.MatrixKeyStatus[i],16);
        }

        //处理行程变化按键事件是否触发
        this.curMaxJourneyKeyStatus = this.getMaxValue(this.MatrixList.MatrixKeyStatus);
        //处理行程变化最大的值
        
        this.curMaxJourney = this.getMaxValue(this.MatrixList.MatrixJourney);
        this.curMaxJourney = this.curMaxJourney/1000;

    },
    //读取全局按键行程设置
    setGlobalJourneyData(reData,HIDDeviceObj)
    {
        const rows      =  this.toHexStringArr(reData);

        var Nval = parseInt(rows[8],16);
            Nval = ((Nval & 0xFF) << 8) | ((Nval & 0xFF00) >> 8);
        var GVal =  Nval + parseInt(rows[7],16);
            HIDDeviceObj.journey_global = GVal/1000;

        // var Tval = parseInt(rows[10],16);
        //     Tval = ((Tval & 0xFF) << 8) | ((Tval & 0xFF00) >> 8);
        // var ZTVal =  Tval + parseInt(rows[9],16);
        //     HIDDeviceObj.safe_zone_top = ZTVal/1000;


        // var Bval = parseInt(rows[12],16);
        //     Bval = ((Bval & 0xFF) << 8) | ((Bval & 0xFF00) >> 8);
        // var ZBVal =  Bval + parseInt(rows[11],16);
        //     HIDDeviceObj.safe_zone_bottom = ZBVal/1000;
    },
    //读取RT全行程响应开关
    setRTJourneyAllData(reData,HIDDeviceObj)
    {
        const rows      =  this.toHexStringArr(reData);
        var Nval = parseInt(rows[6],16);
            HIDDeviceObj.rt_all_journey = Nval;
    },
    //读取全局灯光数据
    setGlobalLigthData(reData,HIDDeviceObj)
    {
        const rows      =  this.toHexStringArr(reData);

        HIDDeviceObj.modeLigth = rows[43];
        HIDDeviceObj.modeChildLigth = rows[41];
        HIDDeviceObj.brightnessLigth = rows[42];
        HIDDeviceObj.speedLigth = rows[44];
        HIDDeviceObj.sleep = rows[45];

    },

    //读取全局功能数据
    setGlobalFuncData(reData,cmdObj,HIDDeviceObj)
    {
        const rows      =  this.toHexStringArr(reData);

        if(parseInt(rows[5],16) == parseInt(cmdObj.RESPONSE_CODE.FUNC_TYPE_CMD.MAC))
        {
            HIDDeviceObj.macStatus = parseInt(rows[6],16);
        }
        else if(parseInt(rows[5],16) == parseInt(cmdObj.RESPONSE_CODE.FUNC_TYPE_CMD.WIN_KEY_STATUS))
        {
            HIDDeviceObj.winKeyStatus = parseInt(rows[6],16);
        }
        else if(parseInt(rows[5],16) == parseInt(cmdObj.RESPONSE_CODE.FUNC_TYPE_CMD.RETE))
        {
            HIDDeviceObj.reteVal = parseInt(rows[6],16);
        }
        else if(parseInt(rows[5],16) == parseInt(cmdObj.RESPONSE_CODE.FUNC_TYPE_CMD.SITE))
        {
            let decoder = new TextDecoder();
            const webSite  =  this.trimSpaces(decoder.decode(reData.slice(6,parseInt(rows[1],16)+3)));

            HIDDeviceObj.curWebSite = webSite;
        }        
        else if(parseInt(rows[5],16) == parseInt(cmdObj.RESPONSE_CODE.FUNC_TYPE_CMD.FIRST_FLAG))
        {
            HIDDeviceObj.FirstFlag = parseInt(rows[6],16);
        }
        else if(parseInt(rows[5],16) == parseInt(cmdObj.RESPONSE_CODE.FUNC_TYPE_CMD.SERIAL_NUMBER))
        {
            var Nval = parseInt(rows[8],16);
                Nval = ((Nval & 0xFF) << 8) | ((Nval & 0xFF00) >> 8);
            var GVal =  Nval + parseInt(rows[7],16);

                if(GVal>10000)
                {
                    Nval = parseInt(rows[7],16);
                    Nval = ((Nval & 0xFF) << 8) | ((Nval & 0xFF00) >> 8);
                    GVal =  Nval + parseInt(rows[6],16);
                }

                HIDDeviceObj.SerialNumber =  GVal;
        }
        else if(parseInt(rows[5],16) == parseInt(cmdObj.RESPONSE_CODE.FUNC_TYPE_CMD.PROFILE_INDEX))
        {
            HIDDeviceObj.ProfileIndex = parseInt(rows[6],16);
        }
    },
    //读取升级签名数据
    setUpgradeSignFuncData(reData,cmdObj,HIDDeviceObj)
    {
        const rows      =  this.toHexStringArr(reData);
        // if(parseInt(rows[5],16) == parseInt(cmdObj.RESPONSE_CODE.UPGRADE_SIGN_TYPE.SIGN1))
        {
            let decoder = new TextDecoder();
            const SignDatas  =  this.trimSpaces(decoder.decode(reData.slice(7,23)));
            const SignSN  =  this.trimSpaces(decoder.decode(reData.slice(23,39)));

            HIDDeviceObj.SignDatas = reData.slice(7,23);
            HIDDeviceObj.SignSN = reData.slice(23,39);
        }
    },
    //读取升级CRC值
    setUpgradeCRCData(reData,cmdObj,HIDDeviceObj)
    {
        // const rows      =  this.toHexStringArr(reData);
        HIDDeviceObj.SignCRC = reData.slice(13,15);
    },
    //读取按键自定义相关数据
    setMatrixLayoutData(reData,cmdObj,HIDDeviceObj)
    {
        const rows      =  this.toHexStringArr(reData);

        if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.FN0) && (HIDDeviceObj.typeMatrixPageID == 1))
        {// 读取Layout0数据 按键自定义数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout0Temp = data;
        }
        else if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.FN0))
        {// 读取Layout0数据 按键自定义数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout0Temp.push.apply(HIDDeviceObj.MatrixList.MatrixLayout0Temp, data);
        }


        if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.FN1) && (HIDDeviceObj.typeMatrixPageID == 1))
        {// 读取Layout1数据 按键自定义数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout1Temp = data;
        }
        else if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.FN1))
        {// 读取Layout1数据 按键自定义数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout1Temp.push.apply(HIDDeviceObj.MatrixList.MatrixLayout1Temp, data);
        }


        if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.JOURNEY4) && (HIDDeviceObj.typeMatrixPageID == 1))
        {// 读取Layout4数据 按键行程自定义数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout4Temp = data;
        }
        else if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.JOURNEY4))
        {// 读取Layout4数据 按键行程自定义数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout4Temp.push.apply(HIDDeviceObj.MatrixList.MatrixLayout4Temp, data);
        }


        if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.RTDOWN14) && (HIDDeviceObj.typeMatrixPageID == 1))
        {// 读取Layout14数据 按键行程RTDOWN数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout14Temp = data;
        }
        else if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.RTDOWN14))
        {// 读取Layout14数据 按键行程RTDOWN数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout14Temp.push.apply(HIDDeviceObj.MatrixList.MatrixLayout14Temp, data);
        }


        if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.RTUP15) && (HIDDeviceObj.typeMatrixPageID == 1))
        {// 读取Layout15数据 按键行程RTUP数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout15Temp = data;
        }
        else if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.RTUP15))
        {// 读取Layout15数据 按键行程RTUP数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout15Temp.push.apply(HIDDeviceObj.MatrixList.MatrixLayout15Temp, data);
        }


        if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.SAFE16) && (HIDDeviceObj.typeMatrixPageID == 1))
        {// 读取Layout16数据 按键安全区数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout16Temp = data;
        }
        else if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.SAFE16))
        {// 读取Layout16数据 按键安全区数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout16Temp.push.apply(HIDDeviceObj.MatrixList.MatrixLayout16Temp, data);
        }

        if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.SAFE17) && (HIDDeviceObj.typeMatrixPageID == 1))
        {// 读取Layout17数据 按键安全区数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout17Temp = data;
        }
        else if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.SAFE17))
        {// 读取Layout17数据 按键安全区数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout17Temp.push.apply(HIDDeviceObj.MatrixList.MatrixLayout17Temp, data);
        }
    

        if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.MODE) && (HIDDeviceObj.typeMatrixPageID == 1))
        {// 读取Layout8 MODE数据 按键MODE数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout8Temp = data;
        }
        else if(HIDDeviceObj.typeMatrixID == parseInt(cmdObj.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.MODE))
        {// 读取Layout8 MODE数据 按键MODE数据
            const data      = rows.slice(5,61);
            HIDDeviceObj.MatrixList.MatrixLayout8Temp.push.apply(HIDDeviceObj.MatrixList.MatrixLayout8Temp, data);
        }

    },
    //格式化Layout0数据MAP化
    formatLayout0(cmdObj,KeyboardMapConf,KeyboardMapFnConf,HIDDeviceObj)
    {
        this.MatrixList.MatrixLayout0 = [];
        //行程数据转化
        for(var i=0;i < this.MatrixList.MatrixLayout0Temp.length;i++)
        {
            if(i%4 == 0)
            {
                let hid = this.MatrixList.MatrixLayout0Temp[i];
                let contentCommand = parseInt(this.MatrixList.MatrixLayout0Temp[i+2],16);

                let typeCommand = parseInt(this.MatrixList.MatrixLayout0Temp[i+3],16);
                    typeCommand =  typeCommand & 0xF0;

                let custom = 
                {
                    "hid":hid,
                    "type":"",//自定义功能类型
                    "name":"",//功能名称
                    "content":"",//功能内容
                };

                //过滤默认功能
                if(contentCommand == parseInt(hid,16))
                {
                    continue;
                }

                switch(typeCommand)
                {
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.KEY,16):
                    {//"KEY";
                        
                        let keyMapObj = this.getBottonHidOJBFromHID(KeyboardMapConf,contentCommand);
                        custom.name = keyMapObj.Name;
                        custom.type = custom.name;
                    }break;
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.MEDIA1,16):
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.MEDIA2,16):
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.MEDIA3,16):
                    {//MEDIA

                        contentCommand = "0x" + (this.MatrixList.MatrixLayout0Temp[i+2]).toString(16) + ',' + "0x" + (this.MatrixList.MatrixLayout0Temp[i+3]).toString(16);
                        let keyMapObj = this.getBottonHidOJBFromHIDMedia(KeyboardMapFnConf,contentCommand);

                        custom.name = keyMapObj.name;
                        custom.type = custom.name;

                    }break;
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.HOTKEY,16):
                    {//HOTKEY

                        contentCommand = "0x" + (this.MatrixList.MatrixLayout0Temp[i+2]).toString(16) + ',' + "0x" + (this.MatrixList.MatrixLayout0Temp[i+3]).toString(16);
                        let keyMapObj = this.getBottonHidOJBFromHIDMedia(KeyboardMapFnConf,contentCommand);
                        if(keyMapObj)
                        {
                            custom.name = keyMapObj.name;
                            custom.type = custom.name;
                        }
                        else
                        {
                            let customObjs =  contentCommand.split(",");
                            let keyMapObj1 = this.getBottonHidOJBFromHID(KeyboardMapConf,customObjs[0]);
                            let keyMapObj2 = this.parseHotKeyCommand(parseInt(customObjs[1],16));

                            custom.type = keyMapObj2 + keyMapObj1.Name;
                        }

                    }break;
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.MOUSE,16):
                    {//MOUSE

                        contentCommand = "0x" + (this.MatrixList.MatrixLayout0Temp[i+2]).toString(16) + ',' + "0x" + (this.MatrixList.MatrixLayout0Temp[i+3]).toString(16);
                        let keyMapObj = this.getBottonHidOJBFromHIDMedia(KeyboardMapFnConf,contentCommand);

                        custom.name = keyMapObj.name;
                        custom.type = custom.name;

                    }break;
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.SYS,16):
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.SYS1,16):
                    {//SYS

                        contentCommand = "0x" + (this.MatrixList.MatrixLayout0Temp[i+2]).toString(16) + ',' + "0x" + (this.MatrixList.MatrixLayout0Temp[i+3]).toString(16);
                        
                        let keyMapObj = this.getBottonHidOJBFromHIDMedia(KeyboardMapFnConf,contentCommand);
                        if(keyMapObj)
                        {
                            custom.name = keyMapObj.name;
                            custom.type = custom.name;
                        }
                        else
                        {
                            console.log(contentCommand);
                            custom.type = "SYS";
                        }

                    }break;
                    default:
                    {
                        console.log(typeCommand);
                        custom.type = "FUNC";

                    }break;
                }

                this.MatrixList.MatrixLayout0.push(custom);
            }
        }

        //格式keyMAP化
        let c= 0;
        for(var i=0;i < 6;i++)
        {
            for(var j=0;j < 21 ;j++)
            {
                for(let z in this.MatrixList.MatrixLayout0)
                {
                    if(this.MatrixList.MatrixLayout0[z].type != "" && this.MatrixList.MatrixLayout0[z].hid == HIDDeviceObj.MatrixList.KeyMap[i][j].hid)
                    {
                        HIDDeviceObj.MatrixList.KeyMap[i][j].custom.name = this.MatrixList.MatrixLayout0[z].type;
                        HIDDeviceObj.MatrixList.KeyMap[i][j].custom.type = this.MatrixList.MatrixLayout0[z].type;
                    }
                }
                c++;
            }
        }
        
    },
    //格式化Layout1数据MAP化
    formatLayout1(cmdObj,KeyboardMapConf,KeyboardMapFnConf,HIDDeviceObj)
    {
        this.MatrixList.MatrixLayout1 = [];

        //行程数据转化
        for(var i=0;i < this.MatrixList.MatrixLayout1Temp.length;i++)
        {
            if(i%4 == 0)
            {
                let hid = this.MatrixList.MatrixLayout1Temp[i];
                let contentCommand = parseInt(this.MatrixList.MatrixLayout1Temp[i+2],16);
                let typeCommand = parseInt(this.MatrixList.MatrixLayout1Temp[i+3],16);
                    typeCommand =  typeCommand & 0xF0;

                let custom = 
                {
                    "hid":hid,
                    "type":"",//自定义功能类型
                    "name":"",//功能名称
                    "content":"",//功能内容
                    "fn_code":"0x" + this.MatrixList.MatrixLayout1Temp[i+2] + "," + "0x" + this.MatrixList.MatrixLayout1Temp[i+3]
                };

                //过滤默认功能
                if(typeCommand == 0 && contentCommand == 1)
                {
                    continue;
                }
                
                //过滤默认功能
                if(contentCommand == parseInt(hid,16))
                {
                    continue;
                }
                                
            
                switch(typeCommand)
                {
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.KEY,16):
                    {//"KEY";
                        
                        let keyMapObj = this.getBottonHidOJBFromHID(KeyboardMapConf,contentCommand);
                        custom.name = keyMapObj.Name;
                        custom.type = custom.name;
                    }break;
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.MEDIA1,16):
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.MEDIA2,16):
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.MEDIA3,16):
                    {//MEDIA

                        contentCommand = "0x" + (this.MatrixList.MatrixLayout1Temp[i+2]).toString(16) + ',' + "0x" + (this.MatrixList.MatrixLayout1Temp[i+3]).toString(16);
                        let keyMapObj = this.getBottonHidOJBFromHIDMedia(KeyboardMapFnConf,contentCommand);

                        custom.name = keyMapObj.name;
                        custom.type = custom.name;

                    }break;
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.HOTKEY,16):
                    {//HOTKEY

                        contentCommand = "0x" + (this.MatrixList.MatrixLayout1Temp[i+2]).toString(16) + ',' + "0x" + (this.MatrixList.MatrixLayout1Temp[i+3]).toString(16);
                        let keyMapObj = this.getBottonHidOJBFromHIDMedia(KeyboardMapFnConf,contentCommand);
                        if(keyMapObj)
                        {
                            custom.name = keyMapObj.name;
                            custom.type = custom.name;
                        }
                        else
                        {
                            let customObjs =  contentCommand.split(",");
                            let keyMapObj1 = this.getBottonHidOJBFromHID(KeyboardMapConf,customObjs[0]);
                            let keyMapObj2 = this.parseHotKeyCommand(parseInt(customObjs[1],16));

                            custom.type = keyMapObj2 + keyMapObj1.Name;
                        }

                    }break;
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.MOUSE,16):
                    {//MOUSE

                        contentCommand = "0x" + (this.MatrixList.MatrixLayout1Temp[i+2]).toString(16) + ',' + "0x" + (this.MatrixList.MatrixLayout1Temp[i+3]).toString(16);
                        let keyMapObj = this.getBottonHidOJBFromHIDMedia(KeyboardMapFnConf,contentCommand);

                        custom.name = keyMapObj.name;
                        custom.type = custom.name;

                    }break;
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.SYS,16):
                    case parseInt(cmdObj.RESPONSE_CODE.CUSTOM_BUTTON_COMMAND_TYPE_CMD.SYS1,16):
                    {//SYS

                        contentCommand = "0x" + (this.MatrixList.MatrixLayout1Temp[i+2]).toString(16) + ',' + "0x" + (this.MatrixList.MatrixLayout1Temp[i+3]).toString(16);
                        
                        let keyMapObj = this.getBottonHidOJBFromHIDMedia(KeyboardMapFnConf,contentCommand);
                        if(keyMapObj)
                        {
                            custom.name = keyMapObj.name;
                            custom.type = custom.name;
                        }
                        else
                        {
                            console.log(contentCommand);
                            custom.type = "SYS";
                        }

                    }break;
                    default:
                    {
                        console.log(typeCommand);

                        custom.type = "FUNC";

                    }break;

                }
                

                this.MatrixList.MatrixLayout1.push(custom);
            }
        }

        //格式keyMAP化
        let c= 0;
        for(var i=0;i < 6;i++)
        {
            for(var j=0;j < 21 ;j++)
            {
                for(let z in this.MatrixList.MatrixLayout1)
                {
                    if(this.MatrixList.MatrixLayout1[z].type != "" && this.MatrixList.MatrixLayout1[z].hid == HIDDeviceObj.MatrixList.KeyMap[i][j].hid)
                    {
                        HIDDeviceObj.MatrixList.KeyMap[i][j].fn_custom.fn_code = this.MatrixList.MatrixLayout1[z].fn_code;
                        HIDDeviceObj.MatrixList.KeyMap[i][j].fn_custom.name = this.MatrixList.MatrixLayout1[z].type;
                        HIDDeviceObj.MatrixList.KeyMap[i][j].fn_custom.type = this.MatrixList.MatrixLayout1[z].type;
                    }
                }
                c++;
            }
        }
        
    },
    //格式化Layout4数据MAP化
    formatLayout4(HIDDeviceObj)
    {
        this.MatrixList.MatrixLayout4 = [];

        //行程数据转化
        for(var i=0;i < this.MatrixList.MatrixLayout4Temp.length;i++)
        {
            if(i%4 == 0)
            {
                let hid = this.MatrixList.MatrixLayout4Temp[i];

                var Nval = parseInt(this.MatrixList.MatrixLayout4Temp[i+3],16);
                    Nval = ((Nval & 0xFF) << 8) | ((Nval & 0xFF00) >> 8);
                var keyVal =  Nval + parseInt(this.MatrixList.MatrixLayout4Temp[i+2],16);

                let custom = 
                {
                    "hid":hid,
                    "journey":keyVal,
                };

                this.MatrixList.MatrixLayout4.push(custom);
            }
        }

        //格式keyMAP化
        let c= 0;
        for(var i=0;i < 6;i++)
        {
            for(var j=0;j < 21 ;j++)
            {
                for(let z in this.MatrixList.MatrixLayout4)
                {
                    if(this.MatrixList.MatrixLayout4[z].hid == HIDDeviceObj.MatrixList.KeyMap[i][j].hid)
                    {
                        HIDDeviceObj.MatrixList.KeyMap[i][j].journey_trigger = (this.MatrixList.MatrixLayout4[z].journey/1000);//.toFixed(3);
                    }
                }
                c++;
            }
        }
    },

    //格式化Layout8数据MAP化
    formatLayout8(HIDDeviceObj)
    {
        this.MatrixList.MatrixLayout8 = [];
        //行程数据转化
        for(var i=0;i < this.MatrixList.MatrixLayout8Temp.length;i++)
        {
            if(i%4 == 0)
            {
                let hid = this.MatrixList.MatrixLayout8Temp[i];

                var Nval = parseInt(this.MatrixList.MatrixLayout8Temp[i+3],16);
                    Nval = ((Nval & 0xFF) << 8) | ((Nval & 0xFF00) >> 8);
                var keyVal =  Nval + parseInt(this.MatrixList.MatrixLayout8Temp[i+2],16);

                let custom = 
                {
                    "hid":hid,
                    "working_mode":keyVal//((keyVal<<4) & 0xFF)>>4,
                };

                this.MatrixList.MatrixLayout8.push(custom);
            }
        }

        //格式keyMAP化
        let c= 0;
        for(var i=0;i < 6;i++)
        {
            for(var j=0;j < 21 ;j++)
            {
                for(let z in this.MatrixList.MatrixLayout8)
                {
                    if(this.MatrixList.MatrixLayout8[z].hid == HIDDeviceObj.MatrixList.KeyMap[i][j].hid)
                    {
                        HIDDeviceObj.MatrixList.KeyMap[i][j].working_mode = this.MatrixList.MatrixLayout8[z].working_mode;
                    }
                }
                c++;
            }
        }
    },

    //格式化Layout14数据MAP化
    formatLayout14(HIDDeviceObj)
    {
        this.MatrixList.MatrixLayout14 = [];
        //行程数据转化
        for(var i=0;i < this.MatrixList.MatrixLayout14Temp.length;i++)
        {
            if(i%4 == 0)
            {
                let hid = this.MatrixList.MatrixLayout14Temp[i];

                var Nval = parseInt(this.MatrixList.MatrixLayout14Temp[i+3],16);
                    Nval = ((Nval & 0xFF) << 8) | ((Nval & 0xFF00) >> 8);
                var keyVal =  Nval + parseInt(this.MatrixList.MatrixLayout14Temp[i+2],16);

                let custom = 
                {
                    "hid":hid,
                    "down":keyVal,
                };

                this.MatrixList.MatrixLayout14.push(custom);
            }
        }

        //格式keyMAP化
        let c= 0;
        for(var i=0;i < 6;i++)
        {
            for(var j=0;j < 21 ;j++)
            {
                for(let z in this.MatrixList.MatrixLayout14)
                {
                    if(this.MatrixList.MatrixLayout14[z].hid == HIDDeviceObj.MatrixList.KeyMap[i][j].hid)
                    {
                        HIDDeviceObj.MatrixList.KeyMap[i][j].journey_RT.down = (this.MatrixList.MatrixLayout14[z].down/1000);//.toFixed(3);
                    }
                }
                c++;
            }
        }
    },
    //格式化Layout15数据MAP化
    formatLayout15(HIDDeviceObj)
    {
        this.MatrixList.MatrixLayout15 = [];
        //行程数据转化
        for(var i=0;i < this.MatrixList.MatrixLayout15Temp.length;i++)
        {
            if(i%4 == 0)
            {
                let hid = this.MatrixList.MatrixLayout15Temp[i];

                var Nval = parseInt(this.MatrixList.MatrixLayout15Temp[i+3],16);
                    Nval = ((Nval & 0xFF) << 8) | ((Nval & 0xFF00) >> 8);
                var keyVal =  Nval + parseInt(this.MatrixList.MatrixLayout15Temp[i+2],16);

                let custom = 
                {
                    "hid":hid,
                    "up":keyVal,
                };

                this.MatrixList.MatrixLayout15.push(custom);
            }
        }

        //格式keyMAP化
        let c= 0;
        for(var i=0;i < 6;i++)
        {
            for(var j=0;j < 21 ;j++)
            {
                for(let z in this.MatrixList.MatrixLayout15)
                {
                    if(this.MatrixList.MatrixLayout15[z].hid == HIDDeviceObj.MatrixList.KeyMap[i][j].hid)
                    {
                        HIDDeviceObj.MatrixList.KeyMap[i][j].journey_RT.up = (this.MatrixList.MatrixLayout15[z].up/1000);//.toFixed(3);
                    }
                }
                c++;
            }
        }
    },
 
    //格式化Layout16数据MAP化
    formatLayout16(HIDDeviceObj)
    {
        this.MatrixList.MatrixLayout16 = [];
        //行程数据转化
        for(var i=0;i < this.MatrixList.MatrixLayout16Temp.length;i++)
        {
            if(i%4 == 0)
            {
                let hid = this.MatrixList.MatrixLayout16Temp[i];

                var Nval = parseInt(this.MatrixList.MatrixLayout16Temp[i+3],16);
                    Nval = ((Nval & 0xFF) << 8) | ((Nval & 0xFF00) >> 8);
                var keyVal =  Nval + parseInt(this.MatrixList.MatrixLayout16Temp[i+2],16);

                let custom = 
                {
                    "hid":hid,
                    "down":keyVal,
                };

                this.MatrixList.MatrixLayout16.push(custom);
            }
        }

        //格式keyMAP化
        let c= 0;
        for(var i=0;i < 6;i++)
        {
            for(var j=0;j < 21 ;j++)
            {
                for(let z in this.MatrixList.MatrixLayout16)
                {
                    if(this.MatrixList.MatrixLayout16[z].hid == HIDDeviceObj.MatrixList.KeyMap[i][j].hid)
                    {
                        HIDDeviceObj.MatrixList.KeyMap[i][j].safe_zone_top = (this.MatrixList.MatrixLayout16[z].down/1000);//.toFixed(3);
                    }
                }
                c++;
            }
        }

        // "safe_zone_top":0.10,
        // "safe_zone_bottom":0.10,
    },
    //格式化Layout17数据MAP化
    formatLayout17(HIDDeviceObj)
    {
        this.MatrixList.MatrixLayout17 = [];
        //行程数据转化
        for(var i=0;i < this.MatrixList.MatrixLayout17Temp.length;i++)
        {
            if(i%4 == 0)
            {
                let hid = this.MatrixList.MatrixLayout17Temp[i];

                var Nval = parseInt(this.MatrixList.MatrixLayout17Temp[i+3],16);
                    Nval = ((Nval & 0xFF) << 8) | ((Nval & 0xFF00) >> 8);
                var keyVal =  Nval + parseInt(this.MatrixList.MatrixLayout17Temp[i+2],16);

                let custom = 
                {
                    "hid":hid,
                    "up":keyVal,
                };

                this.MatrixList.MatrixLayout17.push(custom);
            }
        }

        //格式keyMAP化
        let c= 0;
        for(var i=0;i < 6;i++)
        {
            for(var j=0;j < 21 ;j++)
            {
                for(let z in this.MatrixList.MatrixLayout17)
                {
                    if(this.MatrixList.MatrixLayout17[z].hid == HIDDeviceObj.MatrixList.KeyMap[i][j].hid)
                    {
                        HIDDeviceObj.MatrixList.KeyMap[i][j].safe_zone_bottom = (this.MatrixList.MatrixLayout17[z].up/1000);//.toFixed(3);
                    }
                }
                c++;
            }
        }
    },

        

    getMaxValue(arr) 
    {
        return arr.reduce((max, current) => (current > max) ? current : max, arr[0]);
    },
    getDeviceInfoXS(reData)
    {
        let decoder = new TextDecoder();
        const result = this.toHexString(reData);

        const BoardID  =  parseInt(this.toHexString(Array.from(reData.slice(5,9)).reverse()),16);
        const FWsize   =  parseInt(this.toHexString(reData.slice(10,11)),16);
        const RunMode  =  parseInt(this.toHexString(reData.slice(11,12)),16);
        const SN       =  this.trimSpaces(decoder.decode(reData.slice(13,29)),16);

        var Version  =  this.trimSpaces(decoder.decode(reData.slice(30,44)));

            console.log(Version);
            
            Version = Version.split('.').pop();

        const DateTime =  this.trimSpaces(decoder.decode(reData.slice(46,59)));
        const CheckNum =  this.toHexString(reData.slice(59,63));

        this.FirmwareID = BoardID;
        this.FirmwareNum = Version;
        this.RunMode = RunMode;
        this.SN = SN;
        this.SNDatas = reData.slice(13,29);

        return {"BoardID":BoardID,"FWsize":FWsize,"RunMode":RunMode,"SN":SN,"Version":Version,"DateTime":DateTime,"CheckNum":CheckNum,};

    },
    getADCData(type,reData)
    {

    },
    getSetPRGBCmd(cmd)
    {
        return cmd;
    },
    mergeUint8Arrays(arrays) 
    {
      // 计算总长度
      let totalLength = arrays.reduce((acc, arr) => acc + arr.length, 0);
      // 创建一个新的Uint8Array
      let result = new Uint8Array(totalLength);
      let offset = 0;
      
      arrays.forEach(arr => {
          result.set(arr, offset);
          offset += arr.length;
      });
      
      return result;
    },
    toHexString(bytes) 
    {
        return bytes.reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '');
    },
    toHexStringArr(bytes) 
    {
        var str = bytes.reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '');

        return str.match(/.{1,2}/g);
    },
    fromHexString(hexString) 
    {
        return new Uint8Array(hexString.toString().match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
    },
    trimSpaces(str) 
    {
        str = str.replace(/\u0000/g, '');
        str = str.replace(/\u0010/g, '');
        str = str.replace(/\r/g, '');
        str = str.replace(/\n/g, '');

        return str;
    },
    getHighLowBits(decimal) 
    {
        if (decimal >= 0 && decimal <= 65535) 
        {
            let val = [decimal & 255,decimal >> 8];// 低位在前，高位在后
            val[0] = val[0].toString(16);
            val[1] = val[1].toString(16);

            return  val;

        } 
        else {
            throw new Error('The decimal number must be between 0 and 65535.');
        }
    },
    startCalibrate(cmdObj)
    {
        cmdObj.SET_DEVICE_FUNCTION_OP_CMD[4] = "0x0C";
        const outputReportData = new Uint8Array(cmdObj.SET_DEVICE_FUNCTION_OP_CMD.map(hex => parseInt(hex, 16)));
        this.curDeviceHandle.sendReport(0,outputReportData);
        
        setTimeout(() => 
        {
            this.startListeningNormal(cmdObj);
        }, 100);
    },
    stopCalibrate(cmdObj)
    {
        this.stopListening();
        //保存校准数据
        setTimeout(()=>
        {
            cmdObj.SET_DEVICE_FUNCTION_OP_CMD[4] = "0x0D";
            const outputReportData = new Uint8Array(cmdObj.SET_DEVICE_FUNCTION_OP_CMD.map(hex => parseInt(hex, 16)));
            this.curDeviceHandle.sendReport(0,outputReportData);
        },1000);

    },

    isNumber(value) {
        return typeof value === 'number' && !isNaN(value);
    },
    parseHotKeyCommand(command)
    {
        let ModifierKeys = 
        [
            {
                "Name": "Ctrl",
                "Hid": "0x01",
            },
            {
                "Name": "Shift",
                "Hid": "0x02",
            },
            {
                "Name": "Alt",
                "Hid": "0x04",
            },
            {
                "Name": "Win",
                "Hid": "0x08",
            }
        ];

        let hot = "";
        let ModifierKeysCommand = command & 0x0F;
        for(var i=0;i<ModifierKeys.length;i++)
        {
            if(ModifierKeysCommand & parseInt(ModifierKeys[i].Hid,16))
            {
                hot += ModifierKeys[i].Name + "+";
            }
        }

        return hot;
    },
    //获取热键设置命令格式
    getHotKeyCommand(KeyboardMapConf,Value)
    {
        let commandObj = 
        {   
            "modifier":0,
            "key":0
        };

        let getKeyModifierHID = function(name)
        {
            let ModifierKeys = 
            [
                {
                    "Name": "Ctrl",
                    "Hid": "0x01",
                },
                {
                    "Name": "Shift",
                    "Hid": "0x02",
                },
                {
                    "Name": "Alt",
                    "Hid": "0x04",
                },
                {
                    "Name": "Win",
                    "Hid": "0x08",
                }
            ]

            for(var i=0;i<ModifierKeys.length;i++)
            {
                if(ModifierKeys[i].Name == name)
                {
                    return ModifierKeys[i]
                }
            }
        } 

        
        let task = Value.split("+");
        let hot = 0;
        for(let i=0;i<task.length-1;i++)
        {
            let hidObj  =  getKeyModifierHID(task[i]);

                hidObj.Hid = parseInt(hidObj.Hid,16);
                hot = hot != 0?hot |= hidObj.Hid:hidObj.Hid;
        }

        let lastVal = task[task.length-1];
        let KeyHidObj = this.getBottonHidOJBFromName(KeyboardMapConf,lastVal);
            hot = hot |= 0x60;
            commandObj.modifier = hot.toString(16);
            commandObj.key = KeyHidObj.Hid;

        return commandObj;
    },
    chunkArray(array, chunkSize) 
    {
        let result = [];
        for (let i = 0; i < array.length; i += chunkSize) 
        {
            result.push(array.slice(i, i + chunkSize));
        }
        return result;
    },
    //获取按键行程设置命令格式
    getButtonJourneyCommand(buttons,journey,cmd10)
    {
        //设置参数格式化
        let val = journey*1000;
            val = this.getHighLowBits(val);

        //命令组装
        let commandFormat   = cmd10.SET_DEVICE_BUTTON_JOURNEY_CMD;
        let commandItemGroup = [];
        buttons.forEach(function(el) 
        {
            let keyHid  = el.getAttribute("hid");
            commandFormat[0] = keyHid;
            // commandFormat[4] = keyHid;
            commandFormat[2] = val[0];
            commandFormat[3] = val[1];
            commandItemGroup.push(...commandFormat);
        });
        commandItemGroup = this.chunkArray(commandItemGroup,8);

        //命令分包
        let commandHead     = cmd10.SET_DEVICE_BUTTON_OP_HEAD;
        let commandgroup = [];
        let command56 = [];
        for(let i=0;i<commandItemGroup.length;i++)
        {
            if((i!=0 && i%6 == 0) || i == commandItemGroup.length-1)
            {
                command56.push(...commandItemGroup[i]);
                command56 = commandHead.concat(command56);

                //修改CRC值
                let endData = (command56.length-4 == parseInt(commandHead[1],16))?command56[command56.length-1]:0;
                command56[3] = this.getCRC(commandHead[1],commandHead[2],endData);
                command56[3] = command56[3].toString(16);
                
                commandgroup.push(command56);
                command56 = [];
            } 
            else
            {
                command56.push(...commandItemGroup[i]);
            }
        }

        return commandgroup;
    },
    //获取按键行程恢复默认命令格式
    getButtonRestJourneyCommand(buttons,cmd10)
    {
        //命令组装
        let commandFormat   = cmd10.SET_RESET_BUTTON_JOURNEY_CMD;
        let commandItemGroup = [];
        buttons.forEach(function(el) 
        {
            let keyHid  = el.getAttribute("hid");
            commandFormat[0] = keyHid;
            commandFormat[4] = keyHid;
            // commandFormat[6] = val[0];
            // commandFormat[7] = val[1];
            commandItemGroup.push(...commandFormat);
        });
        commandItemGroup = this.chunkArray(commandItemGroup,8);

        //命令分包
        let commandHead     = cmd10.SET_DEVICE_BUTTON_OP_HEAD;
        let commandgroup = [];
        let command56 = [];
        for(let i=0;i<commandItemGroup.length;i++)
        {
            if((i!=0 && i%6 == 0) || i == commandItemGroup.length-1)
            {
                command56.push(...commandItemGroup[i]);
                command56 = commandHead.concat(command56);

                //修改CRC值
                let endData = (command56.length-4 == parseInt(commandHead[1],16))?command56[command56.length-1]:0;
                command56[3] = this.getCRC(commandHead[1],commandHead[2],endData);
                command56[3] = command56[3].toString(16);
                
                commandgroup.push(command56);
                command56 = [];
            } 
            else
            {
                command56.push(...commandItemGroup[i]);
            }
        }

        return commandgroup;
    },
    //获取按键安全区设置命令格式
    getButtonSafeZoneCommand(buttons,SafeZoneTop,SafeZoneBottom,cmd10)
    {
        //设置参数格式化
        let valSafeZoneTop = SafeZoneTop*1000;
            valSafeZoneTop = this.getHighLowBits(valSafeZoneTop);

        let valSafeZoneBottom = SafeZoneBottom*1000;
            valSafeZoneBottom = this.getHighLowBits(valSafeZoneBottom);

        //命令组装
        let commandFormat   = cmd10.SET_DEVICE_BUTTON_SAFEZONE_CMD;
        let commandItemGroup = [];
        buttons.forEach(function(el) 
        {
            let keyHid  = el.getAttribute("hid");
            commandFormat[0] = keyHid;
            commandFormat[4] = keyHid;

            commandFormat[2] = valSafeZoneTop[0];
            commandFormat[3] = valSafeZoneTop[1];
            commandFormat[6] = valSafeZoneBottom[0];
            commandFormat[7] = valSafeZoneBottom[1];

            commandItemGroup.push(...commandFormat);
        });
        commandItemGroup = this.chunkArray(commandItemGroup,12);


        //命令分包
        let commandHead     = cmd10.SET_DEVICE_BUTTON_OP_HEAD;
        let commandgroup = [];
        let command56 = [];
        for(let i=0;i<commandItemGroup.length;i++)
        {
            if((i!=0 && i%3 == 0) || i == commandItemGroup.length-1)
            {
                command56.push(...commandItemGroup[i]);
                command56 = commandHead.concat(command56);

                //修改CRC值
                let endData = (command56.length == 57)?command56[command56.length-1]:0;
                command56[3] = this.getCRC(commandHead[1],commandHead[2],endData);
                command56[3] = command56[3].toString(16);
                
                commandgroup.push(command56);
                command56 = [];
            } 
            else
            {
                command56.push(...commandItemGroup[i]);
            }
        }

        return commandgroup;
    },
    //获取按键RT设置命令格式
    getButtonRTCommand(buttons,RTUp,RTDown,cmd10)
    {
        //设置参数格式化
        let valRTup = RTUp*1000;
            valRTup = this.getHighLowBits(valRTup);

        let valRTdown = RTDown*1000;
            valRTdown = this.getHighLowBits(valRTdown);

        //命令组装
        let commandFormat   = cmd10.SET_DEVICE_BUTTON_RT_CMD;
        let RTMode = 32;//parseInt(commandFormat[2],16);
        let commandItemGroup = [];
        buttons.forEach(function(el) 
        {
            let keyHid  = el.getAttribute("hid");
            let keyWorkMode  = el.getAttribute("working_mode");

            if(keyWorkMode == null)
            {
                console.log(el.getAttribute("name"));
                console.log(keyWorkMode);
                
                return;
            }
            
            let ADMode = parseInt(keyWorkMode);
            let lastMode = RTMode + ADMode;

            console.log(lastMode.toString(16));

            commandFormat[0] = keyHid;
            commandFormat[2] = lastMode.toString(16);
            commandFormat[4] = keyHid;
            commandFormat[8] = keyHid;

            commandFormat[6] = valRTdown[0];
            commandFormat[7] = valRTdown[1];
            commandFormat[10] = valRTup[0];
            commandFormat[11] = valRTup[1];

            commandItemGroup.push(...commandFormat);
        });
        commandItemGroup = this.chunkArray(commandItemGroup,12);


        //命令分包
        let commandHead     = cmd10.SET_DEVICE_BUTTON_OP_HEAD;
        let commandgroup = [];
        let command56 = [];
        for(let i=0;i<commandItemGroup.length;i++)
        {
            if((i!=0 && i%3 == 0) || i == commandItemGroup.length-1)
            {
                command56.push(...commandItemGroup[i]);
                command56 = commandHead.concat(command56);

                //修改CRC值
                let endData = (command56.length == 57)?command56[command56.length-1]:0;
                command56[3] = this.getCRC(commandHead[1],commandHead[2],endData);
                command56[3] = command56[3].toString(16);
                
                commandgroup.push(command56);
                command56 = [];
            } 
            else
            {
                command56.push(...commandItemGroup[i]);
            }
        }

        return commandgroup;
    },
    getButtonRGBCommand(buttons,color,cmd10)
    {
        let RGBVal = [color.substring(0, 2),color.substring(2, 4),color.substring(4, 6)];

        //命令组装
        let commandItemGroup = [];
        buttons.forEach(function(el) 
        {
            let item = [];
            let keyHid  = el.getAttribute("hid");

            item[0] = keyHid;
            item[1] = RGBVal[0];
            item[2] = RGBVal[1];
            item[3] = RGBVal[2];

            commandItemGroup.push(...item);
        });

        //命令分包
        let commandHead     = cmd10.SET_CUSTOM_BUTTON_RGB_HEAD_CMD;
        let commandgroup    = [];
        let command61       = [];

        let itemCount = 56;
        let tempCount = 1;
        for(let i=0;i<commandItemGroup.length;i++)
        {
            if(tempCount == itemCount || i == commandItemGroup.length-1)
            {
                command61.push(commandItemGroup[i]);
                command61 = commandHead.concat(command61);

                //修改CRC值
                let endData = (command61.length == 61)?command61[command61.length-1]:0;
                command61[3] = this.getCRC(commandHead[1],commandHead[2],endData);
                command61[3] = command61[3].toString(16);
                
                commandgroup.push(command61);
                command61 = [];
                tempCount = 1;
                continue;
            } 
            else
            {
                command61.push(commandItemGroup[i]);
            }

            tempCount++;
        }

        return commandgroup;

    },
    //获取Layout0数据
    getButtonLayoutCustomCompletion(aarCommand,type)
    {
        let itemCommandFormat = ["0x00",type,"0x00","0x00"];
        if(aarCommand.length != 56)
        {
            for(var i=0;i <= (56 - aarCommand.length)/4;i++)
            {
                aarCommand.push(...itemCommandFormat);
            }
        }
        return aarCommand;
    },
    getButtonLayout0CustomCommand(cmd10)
    {
        let KeyMap = this.MatrixList.KeyMap;
        let commandItemGroup = [];
        
        //命令组装
        let itemCommandFormat = ["0xAA","0x00","0x00","0x00"];
        for(var i=0;i< KeyMap.length;i++)
        {
            for(var j=0;j< (KeyMap[i]).length;j++)
            {
                if(KeyMap[i][j].hid != "00")
                {
                    itemCommandFormat[0] = KeyMap[i][j].hid;
                    commandItemGroup.push(...itemCommandFormat);
                }
            }
        }

        //命令分包
        let commandHead     = cmd10.READ_LAYOUT_KEY_CUSTOM_HEAD_CMD;
        let commandgroup    = [];
        let command61       = [];

        let itemCount = 56;
        let tempCount = 1;
        for(let i=0;i<commandItemGroup.length;i++)
        {
            if(tempCount == itemCount || i == commandItemGroup.length-1)
            {
                command61.push(commandItemGroup[i]);
                command61 = this.getButtonLayoutCustomCompletion(command61,cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.FN0);
                command61 = commandHead.concat(command61);

                //修改CRC值
                // let endData = command61[command61.length-1];
                // command61[3] = this.getCRC(commandHead[1],commandHead[2],endData);
                // command61[3] = command61[3].toString(16);
                
                commandgroup.push(command61);
                command61 = [];
                tempCount = 1;
                continue;
            } 
            else
            {
                command61.push(commandItemGroup[i]);
            }

            tempCount++;
        }

        return commandgroup;

    },
    getButtonLayout8CustomCommand(cmd10)
    {
        let KeyMap = this.MatrixList.KeyMap;
        let commandItemGroup = [];
        
        //命令组装
        let itemCommandFormat = ["0xAA","0x08","0x00","0x00"];
        for(var i=0;i< KeyMap.length;i++)
        {
            for(var j=0;j< (KeyMap[i]).length;j++)
            {
                if(KeyMap[i][j].hid != "00")
                {
                    itemCommandFormat[0] = KeyMap[i][j].hid;
                    commandItemGroup.push(...itemCommandFormat);
                }
            }
        }

        //命令分包
        let commandHead     = cmd10.READ_LAYOUT_KEY_CUSTOM_HEAD_CMD;
        let commandgroup    = [];
        let command61       = [];

        let itemCount = 56;
        let tempCount = 1;
        for(let i=0;i<commandItemGroup.length;i++)
        {
            if(tempCount == itemCount || i == commandItemGroup.length-1)
            {
                command61.push(commandItemGroup[i]);
                command61 = this.getButtonLayoutCustomCompletion(command61,cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_MODE_CODE.MODE);
                command61 = commandHead.concat(command61);

                //修改CRC值
                // let endData = command61[command61.length-1];
                // command61[3] = this.getCRC(commandHead[1],commandHead[2],endData);
                // command61[3] = command61[3].toString(16);
                
                commandgroup.push(command61);
                command61 = [];
                tempCount = 1;
                continue;
            } 
            else
            {
                command61.push(commandItemGroup[i]);
            }

            tempCount++;
        }

        return commandgroup;

    },
    getButtonLayout1CustomCommand(cmd10)
    {
        let KeyMap = this.MatrixList.KeyMap;
        let commandItemGroup = [];
        
        //命令组装
        let itemCommandFormat = ["0xAA","0x01","0x00","0x00"];
        for(var i=0;i< KeyMap.length;i++)
        {
            for(var j=0;j< (KeyMap[i]).length;j++)
            {
                if(KeyMap[i][j].hid != "00")
                {
                    itemCommandFormat[0] = KeyMap[i][j].hid;
                    commandItemGroup.push(...itemCommandFormat);
                }
            }
        }

        //命令分包
        let commandHead     = cmd10.READ_LAYOUT_KEY_CUSTOM_HEAD_CMD;
        let commandgroup    = [];
        let command61       = [];

        let itemCount = 56;
        let tempCount = 1;
        for(let i=0;i<commandItemGroup.length;i++)
        {
            if(tempCount == itemCount || i == commandItemGroup.length-1)
            {
                command61.push(commandItemGroup[i]);
                command61 = this.getButtonLayoutCustomCompletion(command61,cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.FN0);
                command61 = commandHead.concat(command61);

                //修改CRC值
                // let endData = command61[command61.length-1];
                // command61[3] = this.getCRC(commandHead[1],commandHead[2],endData);
                // command61[3] = command61[3].toString(16);
                
                commandgroup.push(command61);
                command61 = [];
                tempCount = 1;
                continue;
            } 
            else
            {
                command61.push(commandItemGroup[i]);
            }

            tempCount++;
        }

        return commandgroup;

    },
    getButtonLayout4CustomCommand(cmd10)
    {
        let KeyMap = this.MatrixList.KeyMap;
        let commandItemGroup = [];
        
        //命令组装
        let itemCommandFormat = ["0xAA","0x04","0x00","0x00"];
        for(var i=0;i< KeyMap.length;i++)
        {
            for(var j=0;j< (KeyMap[i]).length;j++)
            {
                if(KeyMap[i][j].hid != "00")
                {
                    itemCommandFormat[0] = KeyMap[i][j].hid;
                    commandItemGroup.push(...itemCommandFormat);
                }
            }
        }

        //命令分包
        let commandHead     = cmd10.READ_LAYOUT_KEY_CUSTOM_HEAD_CMD;
        let commandgroup    = [];
        let command61       = [];

        let itemCount = 56;
        let tempCount = 1;
        for(let i=0;i<commandItemGroup.length;i++)
        {
            if(tempCount == itemCount || i == commandItemGroup.length-1)
            {
                command61.push(commandItemGroup[i]);
                command61 = this.getButtonLayoutCustomCompletion(command61,cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.JOURNEY4);
                command61 = commandHead.concat(command61);

                //修改CRC值
                // let endData = command61[command61.length-1];
                // command61[3] = this.getCRC(commandHead[1],commandHead[2],endData);
                // command61[3] = command61[3].toString(16);
                
                commandgroup.push(command61);
                command61 = [];
                tempCount = 1;
                continue;
            } 
            else
            {
                command61.push(commandItemGroup[i]);
            }

            tempCount++;
        }

        return commandgroup;

    },
    getButtonLayout14CustomCommand(cmd10)
    {
        let KeyMap = this.MatrixList.KeyMap;
        let commandItemGroup = [];
        
        //命令组装
        let itemCommandFormat = ["0xAA","0x14","0x00","0x00"];
        for(var i=0;i< KeyMap.length;i++)
        {
            for(var j=0;j< (KeyMap[i]).length;j++)
            {
                if(KeyMap[i][j].hid != "00")
                {
                    itemCommandFormat[0] = KeyMap[i][j].hid;
                    commandItemGroup.push(...itemCommandFormat);
                }
            }
        }

        //命令分包
        let commandHead     = cmd10.READ_LAYOUT_KEY_CUSTOM_HEAD_CMD;
        let commandgroup    = [];
        let command61       = [];

        let itemCount = 56;
        let tempCount = 1;
        for(let i=0;i<commandItemGroup.length;i++)
        {
            if(tempCount == itemCount || i == commandItemGroup.length-1)
            {
                command61.push(commandItemGroup[i]);
                command61 = this.getButtonLayoutCustomCompletion(command61,cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.JOURNEY4);
                command61 = commandHead.concat(command61);

                //修改CRC值
                // let endData = command61[command61.length-1];
                // command61[3] = this.getCRC(commandHead[1],commandHead[2],endData);
                // command61[3] = command61[3].toString(16);
                
                commandgroup.push(command61);
                command61 = [];
                tempCount = 1;
                continue;
            } 
            else
            {
                command61.push(commandItemGroup[i]);
            }

            tempCount++;
        }

        return commandgroup;

    },
    getButtonLayout15CustomCommand(cmd10)
    {
        let KeyMap = this.MatrixList.KeyMap;
        let commandItemGroup = [];
        
        //命令组装
        let itemCommandFormat = ["0xAA","0x15","0x00","0x00"];
        for(var i=0;i< KeyMap.length;i++)
        {
            for(var j=0;j< (KeyMap[i]).length;j++)
            {
                if(KeyMap[i][j].hid != "00")
                {
                    itemCommandFormat[0] = KeyMap[i][j].hid;
                    commandItemGroup.push(...itemCommandFormat);
                }
            }
        }

        //命令分包
        let commandHead     = cmd10.READ_LAYOUT_KEY_CUSTOM_HEAD_CMD;
        let commandgroup    = [];
        let command61       = [];

        let itemCount = 56;
        let tempCount = 1;
        for(let i=0;i<commandItemGroup.length;i++)
        {
            if(tempCount == itemCount || i == commandItemGroup.length-1)
            {
                command61.push(commandItemGroup[i]);
                command61 = this.getButtonLayoutCustomCompletion(command61,cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.JOURNEY4);
                command61 = commandHead.concat(command61);

                //修改CRC值
                // let endData = command61[command61.length-1];
                // command61[3] = this.getCRC(commandHead[1],commandHead[2],endData);
                // command61[3] = command61[3].toString(16);
                
                commandgroup.push(command61);
                command61 = [];
                tempCount = 1;
                continue;
            } 
            else
            {
                command61.push(commandItemGroup[i]);
            }

            tempCount++;
        }

        return commandgroup;

    },
    getButtonLayout16CustomCommand(cmd10)
    {
        let KeyMap = this.MatrixList.KeyMap;
        let commandItemGroup = [];
        
        //命令组装
        let itemCommandFormat = ["0xAA","0x16","0x00","0x00"];
        for(var i=0;i< KeyMap.length;i++)
        {
            for(var j=0;j< (KeyMap[i]).length;j++)
            {
                if(KeyMap[i][j].hid != "00")
                {
                    itemCommandFormat[0] = KeyMap[i][j].hid;
                    commandItemGroup.push(...itemCommandFormat);
                }
            }
        }

        //命令分包
        let commandHead     = cmd10.READ_LAYOUT_KEY_CUSTOM_HEAD_CMD;
        let commandgroup    = [];
        let command61       = [];

        let itemCount = 56;
        let tempCount = 1;
        for(let i=0;i<commandItemGroup.length;i++)
        {
            if(tempCount == itemCount || i == commandItemGroup.length-1)
            {
                command61.push(commandItemGroup[i]);
                command61 = this.getButtonLayoutCustomCompletion(command61,cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.JOURNEY4);
                command61 = commandHead.concat(command61);

                //修改CRC值
                // let endData = command61[command61.length-1];
                // command61[3] = this.getCRC(commandHead[1],commandHead[2],endData);
                // command61[3] = command61[3].toString(16);
                
                commandgroup.push(command61);
                command61 = [];
                tempCount = 1;
                continue;
            } 
            else
            {
                command61.push(commandItemGroup[i]);
            }

            tempCount++;
        }

        return commandgroup;

    },
    getButtonLayout17CustomCommand(cmd10)
    {
        let KeyMap = this.MatrixList.KeyMap;
        let commandItemGroup = [];
        
        //命令组装
        let itemCommandFormat = ["0xAA","0x17","0x00","0x00"];
        for(var i=0;i< KeyMap.length;i++)
        {
            for(var j=0;j< (KeyMap[i]).length;j++)
            {
                if(KeyMap[i][j].hid != "00")
                {
                    itemCommandFormat[0] = KeyMap[i][j].hid;
                    commandItemGroup.push(...itemCommandFormat);
                }
            }
        }

        //命令分包
        let commandHead     = cmd10.READ_LAYOUT_KEY_CUSTOM_HEAD_CMD;
        let commandgroup    = [];
        let command61       = [];

        let itemCount = 56;
        let tempCount = 1;
        for(let i=0;i<commandItemGroup.length;i++)
        {
            if(tempCount == itemCount || i == commandItemGroup.length-1)
            {
                command61.push(commandItemGroup[i]);
                command61 = this.getButtonLayoutCustomCompletion(command61,cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.JOURNEY4);
                command61 = commandHead.concat(command61);

                //修改CRC值
                // let endData = command61[command61.length-1];
                // command61[3] = this.getCRC(commandHead[1],commandHead[2],endData);
                // command61[3] = command61[3].toString(16);
                
                commandgroup.push(command61);
                command61 = [];
                tempCount = 1;
                continue;
            } 
            else
            {
                command61.push(commandItemGroup[i]);
            }

            tempCount++;
        }

        return commandgroup;

    }
}
